import { render, staticRenderFns } from "./crm-left-side-bar.vue?vue&type=template&id=45171eb8&"
import script from "./crm-left-side-bar.vue?vue&type=script&lang=js&"
export * from "./crm-left-side-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VNavigationDrawer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45171eb8')) {
      api.createRecord('45171eb8', component.options)
    } else {
      api.reload('45171eb8', component.options)
    }
    module.hot.accept("./crm-left-side-bar.vue?vue&type=template&id=45171eb8&", function () {
      api.rerender('45171eb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-crm-app/rfi_process/left-side-bar/crm-left-side-bar.vue"
export default component.exports